//1.index.js里引入router模块
import { createRouter, createWebHashHistory } from "vue-router";

// import FileManage from "@/components/FileManage";
 
// import MainMap from "../components/MainMap.vue";

//2.定义路由  定义的时候，要在src的components下建两个vue组件，像上边一样
const routes = [


    {
        path: "/MainMap",
        name: "MainMap",
        // component: () => import("../components/MainMap.vue")
        component: () => import("../components/MainMap.vue")
    } 

]


//3.创建路由
// const router = createRouter({
//     history: createWebHashHistory(),
//     routes: routes,
// })

//配合上线的更改
const router = createRouter({
    history: createWebHashHistory(),
    base: process.env.BASE_URL,
    routes: routes,
})

router.onError((error) => {
    console.log("发生错误=============",error)
    console.log("此时的router=============",router)
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    // const targetPath = router.history.pending.fullPath;
    // if (isChunkLoadFailed) {
    //     router.replace(targetPath);
    // }
});
export default router